var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "section",
        [
          _c(
            "PageHeader",
            {
              staticStyle: { "padding-top": "1rem" },
              attrs: { pageTitle: "Instalações" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "0.5rem" } },
                [
                  _c("GenericSearchInput", {
                    model: {
                      value: _vm.search.textSearch,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "textSearch", $$v)
                      },
                      expression: "search.textSearch"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectInstallationStatus", {
                    model: {
                      value: _vm.search.installationStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "installationStatus", $$v)
                      },
                      expression: "search.installationStatus"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectAccountManager", {
                    model: {
                      value: _vm.search.accountManagerId,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "accountManagerId", $$v)
                      },
                      expression: "search.accountManagerId"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "VueJsonToCsv",
                    {
                      attrs: {
                        block: "",
                        "json-data": _vm.installationCSVList,
                        separator: ";",
                        "csv-title": "Instalacoes_CSV"
                      }
                    },
                    [
                      _c(
                        "BaseButtonComponent",
                        { attrs: { block: "", variant: "primary-action" } },
                        [_vm._v("\n            CSV\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.installationSummaryList.length
        ? _c("InstallationStatusSummaryTable", {
            attrs: { installationSummaryStatus: _vm.installationSummaryList }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 15,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "d-flex justify-content-between flex-column" },
        [
          !_vm.isLoading && _vm.installationList.length
            ? _c(
                "Table",
                { staticClass: "installation-table" },
                [
                  _c(
                    "TableHeader",
                    _vm._l(_vm.installationColumns, function(
                      installationCol,
                      index
                    ) {
                      return _c(
                        "TableHead",
                        { key: `${installationCol.name}_${index}` },
                        [
                          _c("ColumnHeader", {
                            attrs: {
                              sort: installationCol.sort,
                              somatory: installationCol.somatory,
                              columnName: installationCol.name,
                              columnKey: installationCol.key,
                              columnType: installationCol.columnType,
                              currentColumnFiltered: _vm.currentColumnFiltered,
                              sortDirection: _vm.sortDirection,
                              dataList: _vm.installationList
                            },
                            on: {
                              sortListByKey: function($event) {
                                return _vm.sortListByKey(installationCol.key)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.installationList, function(installation, index) {
                      return _c(
                        "TableRow",
                        { key: `${installation.installationNumber}_${index}` },
                        [
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "8rem" },
                                    attrs: { debounce: "1000" },
                                    model: {
                                      value: installation.installationNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          installation,
                                          "installationNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "installation.installationNumber"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: installation.name }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.dateWithHourFormat(
                                    installation.currentStatusInitDate
                                  )
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.daysInStatus) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "2 rem" },
                                    attrs: {
                                      placeholder: "",
                                      debounce: "1000"
                                    },
                                    model: {
                                      value: installation.lastBillValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          installation,
                                          "lastBillValue",
                                          $$v
                                        )
                                      },
                                      expression: "installation.lastBillValue"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: {
                                  socialNumber: installation.socialNumber
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("SelectInstallationStatus", {
                                model: {
                                  value: installation.installationStatus,
                                  callback: function($$v) {
                                    _vm.$set(
                                      installation,
                                      "installationStatus",
                                      $$v
                                    )
                                  },
                                  expression: "installation.installationStatus"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "2 rem" },
                                    attrs: {
                                      placeholder: "",
                                      debounce: "1000"
                                    },
                                    model: {
                                      value: installation.usage,
                                      callback: function($$v) {
                                        _vm.$set(installation, "usage", $$v)
                                      },
                                      expression: "installation.usage"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "2 rem" },
                                    attrs: {
                                      placeholder: "",
                                      debounce: "1000"
                                    },
                                    model: {
                                      value: installation.cusd,
                                      callback: function($$v) {
                                        _vm.$set(installation, "cusd", $$v)
                                      },
                                      expression: "installation.cusd"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: {
                                  value: installation.freeBalance,
                                  "max-fraction-digits": 0
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "min-width": "70px" } },
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "2 rem" },
                                    attrs: {
                                      placeholder: "",
                                      debounce: "1000"
                                    },
                                    model: {
                                      value: installation.adjustment,
                                      callback: function($$v) {
                                        _vm.$set(
                                          installation,
                                          "adjustment",
                                          $$v
                                        )
                                      },
                                      expression: "installation.adjustment"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: {
                                  value: installation.injection,
                                  "max-fraction-digits": 0
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-input", {
                                staticStyle: { "min-width": "66px" },
                                attrs: { placeholder: "", debounce: "1000" },
                                model: {
                                  value: installation.baseDiscount,
                                  callback: function($$v) {
                                    _vm.$set(installation, "baseDiscount", $$v)
                                  },
                                  expression: "installation.baseDiscount"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _c(
                              "div",
                              { staticStyle: { display: "flex", gap: "1rem" } },
                              [
                                _c(
                                  "BaseButtonComponent",
                                  {
                                    attrs: {
                                      variant: "tertiary-action",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.updateInstallation(
                                          installation
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Gravar\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                installation.installationStatus ===
                                "IN_ANALYSIS"
                                  ? _c(
                                      "BaseButtonComponent",
                                      {
                                        attrs: {
                                          variant: "danger",
                                          size: "sm"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeInstallationById(
                                              installation.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Deletar\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              installation.accountManagerName
                                ? _c("RenderNameColumnValue", {
                                    attrs: {
                                      name: installation.accountManagerName
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.hasFidelity) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.fidelityCounter) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.remainingFidelity) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.couponName) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderPhoneColumnValue", {
                                attrs: { phoneNumber: installation.phone }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.email) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.zipCode) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.city) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: installation.district }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.address) +
                                " " +
                                _vm._s(installation.number) +
                                "\n            " +
                                _vm._s(installation.complement) +
                                "\n            " +
                                _vm._s(installation.state) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _c(
                              "div",
                              [
                                _c(
                                  "BaseButtonComponent",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "primary-action"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openInstallationAddressDialog(
                                          installation
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Endereço\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "BaseButtonComponent",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "primary-action"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openInstallationOwnerDialog(
                                          installation.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Trocar Titular\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "BaseButtonComponent",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "primary-action"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openInstallationResponsibleDialog(
                                          installation
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Info Resp. Cad/Fin\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("DownloadInstallationBillImageButton", {
                                attrs: {
                                  disabled: !installation.consumerBillUrl,
                                  "consumer-bill-url":
                                    installation.consumerBillUrl
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "2 rem" },
                                    attrs: {
                                      placeholder: "",
                                      debounce: "1000"
                                    },
                                    model: {
                                      value: installation.reasonRefusal,
                                      callback: function($$v) {
                                        _vm.$set(
                                          installation,
                                          "reasonRefusal",
                                          $$v
                                        )
                                      },
                                      expression: "installation.reasonRefusal"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  checked: Boolean(installation.isCanceled),
                                  size: "sm"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.setCancelledInstallation(
                                      Boolean(installation.isCanceled),
                                      installation.id
                                    )
                                  }
                                },
                                model: {
                                  value: installation.isCanceled,
                                  callback: function($$v) {
                                    _vm.$set(installation, "isCanceled", $$v)
                                  },
                                  expression: "installation.isCanceled"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  checked: Boolean(installation.isOwner),
                                  size: "sm"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.setOwnPowerPlaint(
                                      Boolean(installation.isOwner),
                                      installation.id
                                    )
                                  }
                                },
                                model: {
                                  value: installation.isOwner,
                                  callback: function($$v) {
                                    _vm.$set(installation, "isOwner", $$v)
                                  },
                                  expression: "installation.isOwner"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderDateColumnValue", {
                                staticStyle: { "text-align": "end" },
                                attrs: { value: installation.canceledAt }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: {
                                  name: installation.responsibleNameRegistration
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: {
                                  "social-number":
                                    installation.responsibleSocialNumberRegistration
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderPhoneColumnValue", {
                                attrs: {
                                  "phone-number":
                                    installation.responsiblePhoneRegistration
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  installation.responsibleEmailRegistration
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  installation.responsibleLinkRegistration
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: {
                                  name: installation.responsibleNameFinancial
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: {
                                  "social-number":
                                    installation.responsibleSocialNumberFinancial
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderPhoneColumnValue", {
                                attrs: {
                                  "phone-number":
                                    installation.responsiblePhoneFinancial
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.responsibleEmailFinancial) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(installation.responsibleLinkFinancial) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : !_vm.isLoading
            ? _c("empty-list")
            : _vm._e(),
          _vm._v(" "),
          _c("AlphabetPagination", {
            on: { "letter-selected": _vm.fetchDataForLetter }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("EditionInstallationAddressDialog", {
        ref: "editModalRef",
        on: { getAll: _vm.getAll }
      }),
      _vm._v(" "),
      _c("ChangeInstallationOwnerDialog", {
        ref: "changeOwnerModalRef",
        on: { getAll: _vm.getAll }
      }),
      _vm._v(" "),
      _c("EditInstallationResponsibleDialog", {
        ref: "editResponsibleModalRef",
        on: { getAll: _vm.getAll }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }